import OrganizationalUnit from './list'
import OrganizationalUnitDetail from './detail'

export { OrganizationalUnit, OrganizationalUnitDetail }



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/index.js